export default __webpack_public_path__ + "static/media/ambient-bright-purple-blue.f964fe89.jpg";